module.exports = __webpack_public_path__ + "img/ico-circle-info.00d54fb7.svg";